import { render } from "./languageTranslation.vue?vue&type=template&id=27f31f57&scoped=true"
import script from "./languageTranslation.vue?vue&type=script&lang=js"
export * from "./languageTranslation.vue?vue&type=script&lang=js"

import "./languageTranslation.vue?vue&type=style&index=0&id=27f31f57&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f31f57"]])

export default __exports__